import { ColDef } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";
import { ReportsNameCell } from "./cells/ReportsNameCell";
import { ReportsSourceCell } from "./cells/ReportsSourceCell";
import { ReportsFrequencyCell } from "./cells/ReportsFrequencyCell";
import { ReportsGridActionsCell } from "./cells/ReportsGridActionsCell";
import { ReportsExecutionCell } from "./cells/ReportsExecutionCell";
import { reportsScheduleSortingFn } from "../utils/helpers/sorting-functions/reportsScheduleSortingFn";
import { reportStatusSortingFn } from "../utils/helpers/sorting-functions/reportStatusSortingFn";
import { reportsSourceQuickFilter } from "../utils/helpers/quick-filters/reportsSourceQuickFilter";
import { reportsFrequencyQuickFilter } from "../utils/helpers/quick-filters/reportsFrequencyQuickFilter";
import { reportsLastExecutionSortingFn } from "../utils/helpers/sorting-functions/reportsLastExecutionSortingFn";
import { reportsLastExecutionQuickFilter } from "../utils/helpers/quick-filters/reportsLastExecutionQuickFilter";
import { reportsNextExecutionQuickFilter } from "../utils/helpers/quick-filters/reportsNextExecutionQuickFilter";
import { reportsNextExecutionSortingFn } from "../utils/helpers/sorting-functions/reportsNextExecutionSortingFn";
import { agGridEmptyColumnToFitEmptySpace } from "../../../../common/ag-grid/utils/constants/agGridEmptyColumnToFitEmptySpace";
import { keyInsensitiveComparatorFn } from "../../../../common/ag-grid/utils/helpers/sortingFunctions/keyInsensitiveComparatorFn";
import { reportsSourceSortingFn } from "../utils/helpers/sorting-functions/reportsSourceSortingFn";
import { ReportsTableData } from "@/store/reports/utils/types/types";
import { createdByColumnDef } from "@/components/pages/common/ag-grid/components/columns/createdByColumnDef";
import { modifiedByColumnDef } from "@/components/pages/common/ag-grid/components/columns/modifiedByColumnDef";
import { notificationMethodColumnDef } from "@/components/pages/common/ag-grid/components/columns/notificationMethodColumnDef";
import { reportsFrequencyValueGetter } from "@/components/pages/reports/components/table/utils/helpers/value-getters/reportsFrequencyValueGetter";
import { reportsLastExecutionValueGetter } from "@/components/pages/reports/components/table/utils/helpers/value-getters/reportsLastExecutionValueGetter";
import { reportsNextExecutionValueGetter } from "@/components/pages/reports/components/table/utils/helpers/value-getters/reportsNextExecutionValueGetter";
import { agGridActionColumnDefaultColumnDef } from "@/components/pages/common/ag-grid/utils/constants/agGridActionColumnDefaultColumnDef";

export const reportsTableColumns: ColDef<ReportsTableData>[] = [
  {
    field: "name",
    colId: "name",
    headerName: "Name",
    flex: 1.5,
    minWidth: 150,
    suppressMovable: true,
    pinned: "left",
    cellStyle: { paddingLeft: 16 },
    suppressColumnsToolPanel: true,
    cellRenderer: ReportsNameCell,
    comparator: keyInsensitiveComparatorFn,
  },
  {
    field: "sourceName",
    headerName: "Source",
    flex: 2,
    minWidth: 170,
    getQuickFilterText: reportsSourceQuickFilter,
    comparator: reportsSourceSortingFn,
    cellRenderer: ({ data }: CustomCellRendererProps<ReportsTableData>) => {
      return (
        <ReportsSourceCell
          id={data?.source_id}
          sourceType={data?.source_type}
          sourceName={data?.sourceName}
        />
      );
    },
  },
  {
    field: "schedule",
    headerName: "Frequency",
    minWidth: 155,
    flex: 1.2,
    getQuickFilterText: reportsFrequencyQuickFilter,
    comparator: reportsScheduleSortingFn,
    cellRenderer: ({ data }: CustomCellRendererProps<ReportsTableData>) => {
      return <ReportsFrequencyCell schedule={data?.schedule} />;
    },
    valueGetter: reportsFrequencyValueGetter,
  },
  {
    field: "last_execution_date",
    headerName: "Last Execution",
    flex: 1.8,
    minWidth: 185,
    getQuickFilterText: reportsLastExecutionQuickFilter,
    comparator: reportsLastExecutionSortingFn,
    cellRenderer: ({ data }: CustomCellRendererProps<ReportsTableData>) => {
      if (!data?.last_execution_date) {
        return "-";
      }

      return (
        <ReportsExecutionCell
          executionDate={data.last_execution_date}
          timeZone={data.time_zone}
        />
      );
    },
    valueGetter: reportsLastExecutionValueGetter,
  },
  {
    field: "next_execution_date",
    headerName: "Next Execution",
    flex: 1.8,
    minWidth: 185,

    getQuickFilterText: reportsNextExecutionQuickFilter,
    comparator: reportsNextExecutionSortingFn,
    cellRenderer: ({ data }: CustomCellRendererProps<ReportsTableData>) => {
      if (!data?.next_execution_date) {
        return "-";
      }

      return (
        <ReportsExecutionCell
          executionDate={data.next_execution_date}
          timeZone={data.time_zone}
        />
      );
    },
    valueGetter: reportsNextExecutionValueGetter,
  },
  createdByColumnDef,
  modifiedByColumnDef,
  notificationMethodColumnDef,

  agGridEmptyColumnToFitEmptySpace,

  {
    ...agGridActionColumnDefaultColumnDef,
    colId: "actions",
    maxWidth: 150,
    width: 150,
    minWidth: 150,
    headerName: "State",
    comparator: reportStatusSortingFn,
    cellRenderer: ReportsGridActionsCell,
  },
];
